import { Component, OnInit, AfterViewInit, ViewChildren, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControlName } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../login.service';
import { GenericValidator } from '../../shared/generic-validator';
import { Observable, fromEvent } from 'rxjs';
import { merge } from 'rxjs/operators';
import { Login } from '@morningstar/shared/auth';
import { TokenService } from '@morningstar/shared/auth';

@Component({
    selector: 'wsg-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})

export class LoginComponent implements OnInit, AfterViewInit {
  @ViewChildren(FormControlName, { read: ElementRef }) formInputElements: ElementRef[];

  errorMessage: string;
  loginForm: FormGroup;
  processing = false;

  displayMessage: { [key: string]: string } = {};
  private validationMessages: { [key: string]: { [key: string]: string } };
  private genericValidator: GenericValidator;

  constructor(private _formBuilder: FormBuilder, private router: Router,
              private loginService: LoginService, private route: ActivatedRoute,
              private tokenService: TokenService) {

    this.validationMessages = {
      userName: {
        required: 'Enter a username'
      },
      password: {
        required: 'Enter a password'
      }
    };

    this.genericValidator = new GenericValidator(this.validationMessages);
  }

  ngOnInit(): void {

    if (this.tokenService.isAuthTokenValid()) {
      this.router.navigate(['/home']);
    }

    this.loginForm = this._formBuilder.group({
      userName: ['', Validators.required],
      password: ['', Validators.required],
      application: 'WSG'
    });
  }

  ngAfterViewInit(): void {

    // Watch for the blur event from any input element on the form.
    const controlBlurs: Observable<any>[] = this.formInputElements
                .map((formControl: ElementRef) => fromEvent(formControl.nativeElement, 'blur'));

    const valueChanges = this.loginForm.valueChanges;

    valueChanges.pipe(merge(...controlBlurs)).subscribe(value => {
      this.displayMessage = this.genericValidator.processMessages(this.loginForm);
    });
  }

  login(): void {
    this.processing = true;
    this.loginService.login(<Login>this.loginForm.value)
                     .subscribe(result => {

                       this.processing = false;

                       if (this.route !== undefined && this.route.snapshot !== undefined &&
                           this.route.snapshot.queryParams['returnUrl'] !== null &&
                           this.route.snapshot.queryParams['returnUrl'] !== '' &&
                           this.route.snapshot.queryParams['returnUrl'] !== undefined){

                         this.router.navigate([this.route.snapshot.queryParams['returnUrl']]);
                       } else {
                         this.router.navigate(['/']);
                       }
                     }, error => {
                      this.errorMessage = <any>error.error;
                      this.processing = false;
                    });
  }
}
